module.exports = new __parcel__URL__("longsleeve_gray.c50c9572.jpg").toString();